module.exports = __webpack_public_path__ + "static/img/image044.f7b6377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image044.png
// module id = zZOM
// module chunks = 1